import React, { useState } from "react";
import ScrollTrigger from "react-scroll-trigger";
import DevIcon from "devicon-react-svg";

import "../../../scss/project-card.scss";

const ICON_ID = 0;
const ICON_TAG = 1;

function ProjectCard({ children, github, website, image, technologies }) {
  const [visibility, setVisibility] = useState(false);

  const getIcon = (id) => {
    switch (id) {
      case "firebase":
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.76489 22.6728L10.8604 2.76365C10.9074 2.46027 11.1421 2.22108 11.4434 2.16969C11.7446 2.11829 12.0447 2.2662 12.1888 2.53698L15.5169 8.78369L7.76489 22.6728ZM29.7457 27.5042L26.7994 9.18169C26.7549 8.91854 26.568 8.70233 26.315 8.62119C26.062 8.54006 25.785 8.60756 25.5971 8.79618L7.01367 27.5042L17.2964 33.2993C17.9421 33.6617 18.7285 33.6617 19.3742 33.2993L29.7457 27.5042ZM21.3899 11.5144L19.0084 6.95787C18.8855 6.72325 18.6435 6.57635 18.3797 6.57635C18.1159 6.57635 17.8738 6.72325 17.751 6.95787L7.29427 25.698L21.3899 11.5144Z"
              fill="white"
            />
          </svg>
        );

      case "jade":
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="24.6055"
              y="7.50461"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <rect
              x="18.1841"
              y="20.3474"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <rect
              x="17.0562"
              y="7.50461"
              width="4.42822"
              height="4.42822"
              fill="white"
            />
            <rect
              x="17.7412"
              y="13.4827"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <rect
              x="10.5449"
              y="10.4937"
              width="4.87105"
              height="4.87105"
              fill="white"
            />
            <rect
              x="5.3623"
              y="6.50671"
              width="3.54258"
              height="3.54258"
              fill="white"
            />
            <rect
              x="11.2095"
              y="5.20508"
              width="3.54258"
              height="3.54258"
              fill="white"
            />
            <rect
              x="24.6055"
              y="13.9261"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <rect
              x="24.6055"
              y="20.3474"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <path
              d="M24.6055 26.7689H30.3622V26.7689C30.3622 29.9482 27.7848 32.5255 24.6055 32.5255V32.5255V26.7689Z"
              fill="white"
            />
            <rect
              x="18.1841"
              y="26.7689"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
            <path
              d="M11.7627 26.7689H17.5194V32.5255V32.5255C14.3401 32.5255 11.7627 29.9482 11.7627 26.7689V26.7689Z"
              fill="white"
            />
            <rect
              x="11.7627"
              y="20.3474"
              width="5.75669"
              height="5.75669"
              fill="white"
            />
          </svg>
        );

      case "repast":
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="30.0374" cy="26.6685" r="3.7356" fill="white" />
            <circle cx="30.3815" cy="10.3521" r="3.05678" fill="white" />
            <path
              d="M12.1444 16.8028C12.9918 16.1179 13.5337 15.0701 13.5337 13.8958C13.5337 11.8327 11.8613 10.1602 9.79802 10.1602C7.73492 10.1602 6.06249 11.8327 6.06249 13.8958C6.06249 15.9589 7.73492 17.6314 9.79802 17.6314C10.228 17.6314 10.641 17.5587 11.0255 17.425L14.2012 22.3154C13.0913 23.2272 12.3316 24.5496 12.1542 26.0505H10.3359C10.0414 24.2815 8.50378 22.9329 6.65106 22.9329C4.58796 22.9329 2.91553 24.6054 2.91553 26.6685C2.91553 28.7316 4.58796 30.4041 6.65106 30.4041C8.48937 30.4041 10.0174 29.0765 10.3288 27.3278H12.1456C12.4455 30.198 14.8724 32.4354 17.822 32.4354C20.9744 32.4354 23.5297 29.88 23.5297 26.7277C23.5297 24.9371 22.7052 23.3391 21.4151 22.2926L22.2624 21.1682C22.742 21.3923 23.2771 21.5174 23.8414 21.5174C25.9047 21.5174 27.5771 19.8449 27.5771 17.7818C27.5771 15.7187 25.9047 14.0462 23.8414 14.0462C21.7783 14.0462 20.1059 15.7187 20.1059 17.7818C20.1059 18.8204 20.5297 19.76 21.2139 20.4371L20.3361 21.6021C19.5776 21.2294 18.7242 21.0201 17.822 21.0201C16.9057 21.0201 16.0398 21.236 15.2725 21.6198L12.1444 16.8028Z"
              fill="white"
            />
          </svg>
        );

      case "jupyter":
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.3442 19.1236V19.1022V15.8389H7.05989V19.3746C7.09315 19.6596 7.06867 19.9483 6.98792 20.2236C6.90717 20.4989 6.7718 20.7551 6.58989 20.9769C6.25179 21.2686 5.81859 21.4263 5.37214 21.4202L5.29736 20.8861C5.58534 20.8863 5.86315 20.7797 6.07715 20.587C6.26942 20.3627 6.3442 20.0583 6.3442 19.1236ZM11.6817 18.7023C11.6817 19.1029 11.6817 19.4607 11.7137 19.7705H11.0781L11.0354 19.1349C10.9025 19.3598 10.7123 19.5455 10.4844 19.6731C10.2564 19.8007 9.99872 19.8656 9.73752 19.8613C9.11797 19.8613 8.38091 19.5248 8.38091 18.1522V15.8716H9.09661V18.008C9.09661 18.7504 9.32627 19.2471 9.97253 19.2471C10.1055 19.2485 10.2374 19.2234 10.3605 19.1732C10.4836 19.1229 10.5955 19.0486 10.6895 18.9546C10.7835 18.8606 10.8578 18.7487 10.9081 18.6256C10.9583 18.5025 10.9834 18.3706 10.982 18.2376V15.8449H11.6977V18.681L11.6817 18.7023ZM13.0383 17.1423C13.0383 16.6456 13.0383 16.2396 13.0062 15.8711H13.6472L13.6792 16.5387C13.822 16.2975 14.0276 16.0996 14.274 15.966C14.5204 15.8325 14.7985 15.7683 15.0785 15.7803C16.0292 15.7803 16.7449 16.5761 16.7449 17.7618C16.7449 19.1612 15.885 19.8555 14.9557 19.8555C14.7178 19.8661 14.4813 19.8152 14.2689 19.7076C14.0565 19.6 13.8754 19.4393 13.7433 19.2413V21.3777H13.0383V17.1583V17.1423ZM13.7433 18.1838C13.7452 18.2807 13.756 18.3772 13.7753 18.4722C13.8359 18.7093 13.9739 18.9195 14.1674 19.0694C14.3608 19.2194 14.5988 19.3005 14.8435 19.3C15.5966 19.3 16.0399 18.6858 16.0399 17.7939C16.0399 17.0141 15.6233 16.3465 14.8702 16.3465C14.5722 16.3709 14.2933 16.5031 14.0859 16.7185C13.8784 16.9338 13.7566 17.2174 13.7433 17.5161V18.1838ZM18.0201 15.8676L18.88 18.1695C18.9708 18.4259 19.0669 18.7357 19.131 18.9653C19.2058 18.7303 19.2859 18.4312 19.382 18.1535L20.1618 15.8676H20.9149L19.8467 18.6449C19.3126 19.9801 18.9868 20.6691 18.4954 21.0857C18.2479 21.3118 17.9462 21.47 17.6195 21.545L17.4433 20.9468C17.6717 20.8718 17.8837 20.754 18.0682 20.5997C18.3287 20.3873 18.5355 20.1165 18.6717 19.8092C18.7008 19.756 18.7207 19.6982 18.7304 19.6383C18.7244 19.5738 18.7081 19.5108 18.6824 19.4514L17.2296 15.8569H18.0094L18.0201 15.8676ZM22.8149 14.747V15.8686H23.8403V16.4027H22.8149V18.5071C22.8149 18.9878 22.9537 19.2655 23.349 19.2655C23.4894 19.2678 23.6294 19.2517 23.7656 19.2175L23.7976 19.7516C23.5934 19.8223 23.378 19.8549 23.162 19.8477C23.019 19.8566 22.8758 19.8346 22.7421 19.7829C22.6084 19.7313 22.4875 19.6514 22.3876 19.5486C22.17 19.2576 22.0708 18.895 22.1099 18.5338V16.3974H21.501V15.8633H22.1205V14.9126L22.8149 14.747ZM25.1588 17.944C25.1443 18.1251 25.1693 18.3072 25.232 18.4777C25.2948 18.6483 25.3939 18.8031 25.5224 18.9316C25.6509 19.0601 25.8057 19.1592 25.9762 19.222C26.1468 19.2847 26.3289 19.3097 26.51 19.2952C26.8764 19.3034 27.2404 19.2343 27.5782 19.0923L27.7011 19.6264C27.2865 19.7972 26.8407 19.879 26.3925 19.8667C26.1312 19.8846 25.8692 19.8458 25.6243 19.7529C25.3795 19.66 25.1576 19.5152 24.9739 19.3285C24.7903 19.1418 24.6492 18.9176 24.5603 18.6712C24.4714 18.4249 24.4369 18.1622 24.4591 17.9012C24.4591 16.7262 25.1588 15.7969 26.3017 15.7969C27.5836 15.7969 27.904 16.9185 27.904 17.6342C27.9109 17.7445 27.9109 17.8551 27.904 17.9653H25.1427L25.1588 17.944ZM27.2524 17.4099C27.273 17.2671 27.2628 17.1215 27.2224 16.983C27.182 16.8445 27.1124 16.7163 27.0183 16.607C26.9241 16.4976 26.8076 16.4098 26.6767 16.3493C26.5457 16.2887 26.4033 16.257 26.259 16.2562C25.9655 16.2775 25.6906 16.4075 25.4881 16.6209C25.2855 16.8343 25.17 17.1157 25.1641 17.4099H27.2524ZM28.9899 17.0821C28.9899 16.6227 28.9899 16.2275 28.9579 15.8643H29.5988V16.6281H29.6309C29.6981 16.3924 29.8371 16.1834 30.0285 16.0303C30.22 15.8771 30.4543 15.7874 30.6991 15.7735C30.7664 15.7647 30.8347 15.7647 30.902 15.7735V16.4412C30.8204 16.4317 30.738 16.4317 30.6563 16.4412C30.4139 16.4505 30.1831 16.5479 30.0072 16.715C29.8313 16.882 29.7222 17.1075 29.7003 17.3491C29.6803 17.4584 29.6696 17.5692 29.6683 17.6803V19.7579H28.9632V17.0874L28.9899 17.0821Z"
              fill="white"
            />
            <path
              d="M28.6764 5.13834C28.6984 5.49715 28.613 5.85437 28.4312 6.16449C28.2494 6.47461 27.9794 6.72359 27.6556 6.87972C27.3318 7.03585 26.9688 7.09206 26.6129 7.04119C26.2571 6.99031 25.9244 6.83465 25.6573 6.59405C25.3902 6.35345 25.2008 6.03878 25.1132 5.69014C25.0256 5.3415 25.0437 4.97467 25.1653 4.63638C25.2869 4.29809 25.5065 4.00364 25.796 3.79057C26.0855 3.57749 26.4319 3.45541 26.791 3.4399C27.0265 3.42694 27.2622 3.46066 27.4846 3.53912C27.707 3.61757 27.9117 3.73922 28.0869 3.89706C28.2621 4.05491 28.4044 4.24583 28.5056 4.45885C28.6067 4.67187 28.6648 4.9028 28.6764 5.13834Z"
              fill="white"
            />
            <path
              d="M18.1155 26.0568C13.3086 26.0568 9.08388 24.3317 6.89941 21.784C7.74699 24.0759 9.27636 26.0532 11.2816 27.4496C13.2869 28.8461 15.6719 29.5946 18.1155 29.5946C20.5591 29.5946 22.9441 28.8461 24.9494 27.4496C26.9547 26.0532 28.484 24.0759 29.3316 21.784C27.1525 24.3317 22.9438 26.0568 18.1155 26.0568Z"
              fill="white"
            />
            <path
              d="M18.1155 9.49016C22.9224 9.49016 27.1472 11.2153 29.3316 13.7629C28.484 11.4711 26.9547 9.49381 24.9494 8.09737C22.9441 6.70093 20.5591 5.95233 18.1155 5.95233C15.6719 5.95233 13.2869 6.70093 11.2816 8.09737C9.27636 9.49381 7.74699 11.4711 6.89941 13.7629C9.08388 11.21 13.2873 9.49016 18.1155 9.49016Z"
              fill="white"
            />
            <path
              d="M11.4982 31.0146C11.5264 31.4665 11.4194 31.9167 11.1909 32.3076C10.9623 32.6985 10.6226 33.0126 10.2149 33.2097C9.80726 33.4068 9.35014 33.4782 8.90181 33.4146C8.45346 33.351 8.03419 33.1554 7.69742 32.8527C7.36065 32.55 7.12162 32.1539 7.01078 31.7148C6.89994 31.2757 6.92232 30.8136 7.07505 30.3873C7.22779 29.961 7.50397 29.5899 7.86841 29.3211C8.23286 29.0523 8.66906 28.8982 9.12145 28.8782C9.4178 28.8623 9.71437 28.905 9.99423 29.0038C10.2741 29.1026 10.5317 29.2556 10.7524 29.454C10.9731 29.6524 11.1526 29.8923 11.2806 30.1601C11.4085 30.4279 11.4825 30.7182 11.4982 31.0146Z"
              fill="white"
            />
            <path
              d="M7.44538 8.90953C7.18637 8.91668 6.93102 8.84709 6.71146 8.70951C6.49189 8.57193 6.31791 8.37249 6.21138 8.1363C6.10486 7.90009 6.07055 7.63767 6.11278 7.38202C6.15501 7.12638 6.27188 6.88892 6.4487 6.69952C6.62553 6.51012 6.8544 6.37723 7.10655 6.31757C7.3587 6.2579 7.62286 6.27412 7.86581 6.36419C8.10877 6.45426 8.31967 6.61415 8.47198 6.82376C8.62431 7.03337 8.71125 7.28334 8.72188 7.54223C8.732 7.8923 8.60363 8.23224 8.36464 8.48822C8.12565 8.74422 7.79532 8.89561 7.44538 8.90953Z"
              fill="white"
            />
          </svg>
        );

      case "jasmin":
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.76709 24.26L12.251 22.6097H12.4344V23.8933C12.4344 25.5313 12.8744 26.8577 13.7546 27.8723C14.8426 29.1314 16.2667 29.7609 18.027 29.7609C19.7873 29.7609 21.2114 29.1314 22.2994 27.8723C23.1795 26.8577 23.6196 25.5313 23.6196 23.8933V8.344H13.1128V8.16064L14.5981 5.00677H27.2869V23.8933C27.2869 26.5337 26.4617 28.7035 24.8115 30.4027C23.0756 32.1752 20.8141 33.0615 18.027 33.0615C15.2765 33.0615 13.015 32.1752 11.2425 30.4027C9.59223 28.7647 8.76709 26.7171 8.76709 24.26Z"
              fill="white"
            />
          </svg>
        );

      case "c":
        return (
          <svg
            width="35"
            height="40"
            viewBox="0 0 35 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.484 8.71815C33.9006 8.95852 34.2788 9.37517 34.5545 9.8495C34.8301 10.3271 35 10.8623 35 11.3431V28.0482C35 28.529 34.8301 29.0674 34.5545 29.5418C34.2788 30.0162 33.9006 30.4329 33.484 30.6732L19.016 39.0258C18.1795 39.5066 16.8173 39.5066 15.984 39.0258L1.51602 30.6732C1.09936 30.4329 0.721165 30.0162 0.445525 29.5419C0.169884 29.0643 0 28.529 0 28.0483V11.3431C0 10.3816 0.682692 9.19892 1.51603 8.71815L15.984 0.365582C16.8173 -0.115187 18.1827 -0.115187 19.016 0.365582L33.484 8.71815ZM5.83333 19.6957C5.83333 26.1284 11.0673 31.3624 17.5 31.3624C21.6506 31.3624 25.5224 29.1284 27.6026 25.5387L22.5545 22.6156C21.5128 24.4137 19.5769 25.5323 17.5 25.5323C14.282 25.5323 11.6667 22.9137 11.6667 19.6989C11.6667 16.481 14.282 13.8656 17.5 13.8656C19.5769 13.8656 21.5128 14.981 22.5545 16.7823L27.6026 13.8592C25.5224 10.263 21.6506 8.02905 17.5 8.02905C11.0673 8.02905 5.83333 13.263 5.83333 19.6957Z"
              fill="black"
            />
          </svg>
        );

      default:
        return <DevIcon icon={id} />;
    }
  };

  return (
    <ScrollTrigger
      onEnter={() => setVisibility(true)}
      onExit={() => setVisibility(false)}
      className="project-card"
      data-visible={visibility}
    >
      {image && <img src={image.src} alt={image.alt} />}
      <div className="information">
        <section className="description">{children}</section>
        <section className="technologies">
          {technologies &&
            technologies.map((technology) => (
              <div key={technology[ICON_TAG]} className="icon">
                {getIcon(technology[ICON_ID])}
                <span>{technology[ICON_TAG]}</span>
              </div>
            ))}
        </section>
        <section className="buttons">
          {github && (
            <a href={github} target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
          )}
          {website && (
            <a href={website} target="_blank" rel="noopener noreferrer">
              Website
            </a>
          )}
        </section>
      </div>
    </ScrollTrigger>
  );
}

export default ProjectCard;
